export default __webpack_public_path__ + "static/media/bbg.92ef1c10.png";